import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import * as globals from '@reusable/services/globals';

@Injectable()
export class PaymentCustomerService {
  response;
  constructor(private router: Router, private httpClient: HttpClient, private gtn: globals.GetTokenNow) {}

  creditCardDirectOrder(orderId, paymentType, email?, olp_id?) {
    return this.httpClient
      .post(
        `${globals.domain}/customer/payments/web/direct-orders/paytabs/create-payment-page/`,
        { orderId, paymentType, olp_id, email },
        this.gtn.getHeaders()
      )
      .pipe(map((res:any) => {
        this.response = res;
        return this.response;
      }));
  }

  codOrder(body) {
    return this.httpClient.post(`${globals.domain}/customer/payments/common/orders/cod/`, body, this.gtn.getHeaders()).pipe(map(res => res as any));
  }

  codDirectOrder(body) {
    return this.httpClient.post(`${globals.domain}/customer/payments/common/direct-orders/cod/`, body, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  walletDirectOrder(body) {
    return this.httpClient.post(`${globals.domain}/customer/payments/cart/wallet/`, body, this.gtn.getHeaders()).pipe(map(res => res as any));
  }

  customerWalletView() {
    return this.httpClient.get(`${globals.domain}/customer/wallets/view/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }

  hyperpay({ id, discountCode }) {
    return this.httpClient
      .post(`${globals.domain}/customer/payments/cart/hyperpay/verify/`, { id, discountCode }, this.gtn.getHeaders())
      .pipe(map(res => {
        const response = res as any;
        return response;
      }));
  }

  hyperpayView() {
    const requestOptions = this.gtn.getHeaders();
    requestOptions['responseType'] = 'blob';

    return this.httpClient.get(`${globals.domain}/customer/payments/cart/hyperpay/create/`, requestOptions).pipe(map(res => res as any));
  }

  cancelBankTransferPayment(body) {
    return this.httpClient
      .post(`${globals.domain}/customer/payments/direct-orders/bank-transfer/cancel/`, body, this.gtn.getHeaders())
      .pipe(map(res => res as any));
  }
}